module.exports = __webpack_public_path__ + "static/offices-content-image-6@2x-3f194a1db01282c1267fea3f1c3df430.jpg";